import type { TAuth } from "@/types"
import { api } from "./api"

export async function refreshAPIAuth(): Promise<TAuth | null> {
  if (!api.defaults.headers.Authorization) return null
  const response = await api.get(`/auth/refresh`)
  return response.data
}
